import auth1 from "../assets/pictures/home/auth1.jpg";
import auth2 from "../assets/pictures/home/auth2.jpeg";
import logo from "../assets/logos/RG copy 2.png";
import bride1 from "../assets/pictures/home/bride1.jpeg";
import bride2 from "../assets/pictures/home/bride2.jpeg";
import bride3 from "../assets/pictures/home/bride3.jpeg";
import bride4 from "../assets/pictures/home/bride4.jpeg";
import { cls } from "../components/Utility";
import { Link } from "react-router-dom";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";
import w1 from "../assets/pictures/weddings/w1.webp";
import w2 from "../assets/pictures/weddings/w2.webp";
import w3 from "../assets/pictures/weddings/w3.webp";
import w4 from "../assets/pictures/weddings/w4.webp";
import w5 from "../assets/pictures/weddings/w5.webp";
import w6 from "../assets/pictures/weddings/w6.webp";
import w7 from "../assets/pictures/weddings/w7.webp";
import w8 from "../assets/pictures/weddings/w8.webp";
import w9 from "../assets/pictures/weddings/w9.webp";
import w10 from "../assets/pictures/weddings/w10.webp";

export default function Weddings() {
  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={w5} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                CULTURE X RICH HERITAGE x TRADITION
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={w5} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                CULTURE X RICH HERITAGE x TRADITION
              </h1>
            </div>
          </div>
        </div>
      </div>

      <p className="mt-[30px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        We celebrate the union of culture, rich heritage, and timeless
        traditions through our lens. Every frame we capture reflects a deep
        respect for our roots, blending the grandeur of legacy with a modern
        artistic touch. With each story, we honor the essence of heritage,
        creating memories that resonate for generations.
      </p>
      <div className="flex justify-center mb-[10px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>
      <div className="flex flex-col gap-[10px] xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <img
          src={w6}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <img
          src={w7}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <img
          src={w8}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <img
          src={w9}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <img
          src={w10}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
      </div>
      {/* 
      <div className="mt-[20px] flex flex-col items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <img
          src={auth2}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <p className="mt-[10px] font-[Headings] font-semibold tracking-widest text-[25px] text-center">
          THE HERITAGE COLLECTION
        </p>
        <p className="text-[14px] font-[description1] mt-[10px]">
          The India that was & the India that is
        </p>

        <Link to="/the-heritage-collection">
          {" "}
          <div className="flex justify-center mb-[30px] ">
            <div className="rounded-none border-[1.5px] pt-[10px] pb-[10px] pl-[20px] pr-[20px] bg-[black] mt-[30px] text-white font-[Headings] text-[16px] w-[120px] text-center">
              EXPLORE
            </div>
          </div>{" "}
        </Link>
      </div>

      <div className="mt-[10px] flex flex-col items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <img
          src={auth2}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <p className="mt-[10px] font-[Headings] font-semibold tracking-widest text-[25px] text-center">
          THE LEGACY OF CULTURE
        </p>
        <p className="text-[14px] font-[description1] mt-[10px]">
          Preserving Cultural Legacies Through Premium lens
        </p>

        <Link to="/the-legacy-of-culture">
          {" "}
          <div className="flex justify-center mb-[30px] ">
            <div className="rounded-none border-[1.5px] pt-[10px] pb-[10px] pl-[20px] pr-[20px] bg-[black] mt-[30px] text-white font-[Headings] text-[16px] w-[120px] text-center">
              EXPLORE
            </div>
          </div>
        </Link>
      </div>

      <div className="mt-[10px] flex flex-col items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <img
          src={auth2}
          className="xl:w-[700px] w-full h-[500px] xl:h-[700px] object-cover"
        />
        <p className="mt-[10px] font-[Headings] font-semibold tracking-widest text-[25px] text-center">
          THE RITUALS COLLECTION
        </p>
        <p className="text-[14px] font-[description1] mt-[10px]">
          Timeless Traditions, Captured Perfectly
        </p>

        <Link to="/the-rituals-collection">
          {" "}
          <div className="flex justify-center mb-[30px] ">
            <div className="rounded-none border-[1.5px] pt-[10px] pb-[10px] pl-[20px] pr-[20px] bg-[black] mt-[30px] text-white font-[Headings] text-[16px] w-[120px] text-center">
              EXPLORE
            </div>
          </div>
        </Link>
      </div> */}

      <p className="font-[Headings] font-semibold tracking-widest text-[25px] text-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mt-[30px]">
        SOMETHING SPECIAL IN WEDDINGS
      </p>
      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mt-[30px] mb-[30px]",
          "xl:flex xl:flex-row xl:justify-center xl:gap-[10px] xl:mt-[60px] xl:mb-[60px]"
        )}
      >
        <img
          src={w1}
          className="xl:w-[318px] xl:h-[390px] w-full h-[500px] object-cover transform transition-transform duration-300 ease-in-out hover:scale-95"
        />
        <img
          src={w2}
          className="xl:w-[318px] xl:h-[390px]  w-full h-[500px] object-cover transform transition-transform duration-300 ease-in-out hover:scale-95"
        />
        <img
          src={w3}
          className="xl:w-[318px] xl:h-[390px]  w-full h-[500px] object-cover transform transition-transform duration-300 ease-in-out hover:scale-95"
        />
        <img
          src={w4}
          className="xl:w-[318px] xl:h-[390px]  w-full h-[500px] object-cover transform transition-transform duration-300 ease-in-out hover:scale-95"
        />
      </div>

      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
